/** @jsx jsx */
import React from 'react'
import PropTypes from 'prop-types'
import { css, jsx } from '@emotion/react'

import QuoteSectionWrapper from 'agency/digital_renderer/components/QuoteSectionWrapper'

import QuoteItem from './QuoteItem'
import styles from './styles.scss'

const QuoteSection = (props) => {
  const { campaignQuoteSection, customCSS } = props

  const customSectionCSS = customCSS.quoteSection

  return (
    <QuoteSectionWrapper
      campaignQuoteSection={campaignQuoteSection}
      render={({
        hidePrices, quoteItems, showSubtotal, formattedSubtotal,
      }) => (
        <div
          className={styles.root}
          css={
            customSectionCSS
              ? css`
                  ${customSectionCSS}
                `
              : null
          }
        >
          <div className={styles.header} data-id="section-header">
            <h3>{campaignQuoteSection.title}</h3>
            {showSubtotal && formattedSubtotal && (
            <span className={styles.subtotal} data-id="section-subtotal">
              {formattedSubtotal}
            </span>
            )}
          </div>

          <ul className={styles.items} data-id="item-holder">
            {quoteItems.map(item => (
              <QuoteItem key={item.id} campaignQuoteItem={item} customCSS={customCSS} showPrice={!hidePrices} />
            ))}
          </ul>
        </div>
      )}
    />
  )
}

QuoteSection.propTypes = {
  campaignQuoteSection: PropTypes.object.isRequired,
  customCSS: PropTypes.object,
}

export default QuoteSection
